// extracted by mini-css-extract-plugin
module.exports = {"EmployeeName":"employeeItem-module--EmployeeName--3ggKR","EmployeePosition":"employeeItem-module--EmployeePosition--2Y40C"};